<ng-container [ngSwitch]="type">
  <app-message-text *ngSwitchCase="'text'" [message]="message"></app-message-text>

  <app-message-image *ngSwitchCase="'image'" [message]="message"></app-message-image>

  <app-message-video *ngSwitchCase="'video'" [message]="message"></app-message-video>

  <app-message-audio *ngSwitchCase="'audio'" [message]="message"></app-message-audio>

  <app-message-document *ngSwitchCase="'document'" [message]="message"></app-message-document>

  <app-message-quote *ngSwitchCase="'quote'" [message]="message"></app-message-quote>

  <!-- Default fallback -->
  <app-message-text *ngSwitchDefault [message]="message"></app-message-text>

  @if (showInfo && !((type === 'image' || type === 'video') && !message.text)){
    <div class="message-bubble-time-transparent">
      {{ message.creationDate | date: messageDateFormat }}
    </div>
  }

  @if (showAiInsights && message.aiInsights) {
    <app-message-ai-insights
      [aiInsights]="message.aiInsights"
      [isSender]="message.type === MessageType.SENT">
    </app-message-ai-insights>
  }

</ng-container>
